<template>
  <ControlCenterLayout type="api">
    <BaseLayout>
      <div class="tw-flex tw-w-full tw-gap-4 lg:tw-mt-8 tw-mb-20 tw-mt-4">
        <div
          class="tw-hidden md:tw-block tw-w-48 tw-flex-none tw-rounded-lg tw-bg-white tw-py-5"
          style="height: 786px"
          v-if="path !== '/cloudWord/cloud-word'"
        >
          <ul class="tw-list-none tw-flex tw-flex-col tw-gap-5">
            <li
              v-for="item in menuList"
              :key="item.path"
              class="tw-rounded-lg tw-pl-7 tw-py-3 tw-mx-2.5 tw-text-textMain tw-cursor-pointer menu-hover"
              :class="{
                'menu-active': activateMenu === item.id,
              }"
              @click="handleMenuClick(item)"
            >
              <span class="tw-text-base tw-font-bold">{{ $t(item.name) }}</span>
            </li>
          </ul>
        </div>
        <div class="tw-flex-1 app-main">
          <router-view v-if="path === '/cloudWord/cloud-word'"></router-view>
          <cloud-server
            v-else
            :item="itemMenu"
            :key="activateMenu"
          ></cloud-server>
        </div>
      </div>
    </BaseLayout>
  </ControlCenterLayout>
</template>

<script>
import BaseLayout from "@/layout/BaseLayout.vue";
import ControlCenterLayout from "@/layout/ControlCenterLayout.vue";
import CloudServer from "./cloud-server/cloud-server.vue";
import { productsApi } from "@/api/modules/home";
export default {
  name: "UserCenter",
  components: { BaseLayout, ControlCenterLayout, CloudServer },
  data() {
    return {
      menuList: [],
    };
  },
  computed: {
    // 路径
    path() {
      return this.$route.path;
    },
    activateMenu: {
      get() {
        const id = this.$route.params.id;
        return id ? parseInt(id) : 18;
      },
      set(value) {},
    },
    itemMenu: {
      get() {
        const id = this.$route.params.id;
        if (id) {
          const menuItem = this.menuList.find((item) => item.id == id);
          return menuItem || this.menuList[0];
        }
        return this.menuList[0];
      },
      set(value) {},
    },
  },
  watch: {
    path(newPath) {
      const id = this.$route.params.id;
      if (id) {
        this.updateActiveMenuById(id);
      }
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let params = {
        pageIndex: 1,
        pageSize: 20,
        property: 3,
      };
      const { code, data } = await productsApi(params);
      if (code !== 0) return;
      // 获取前5条数据
      this.menuList = data?.list?.sort((a, b) => a.id - b.id) || [];
    },
    handleMenuClick(item) {
      this.activateMenu = item.id;
      this.itemMenu = item;
      this.$router.push(`/cloudWord/cloud-server/${item.id}`);
      this.$store.commit("SET_CURRENTSTEP", null);
    },
    updateActiveMenuById(id) {
      const menuItem = this.menuList.find((item) => item.id == id);
      if (menuItem) {
        this.activateMenu = menuItem.id;
        this.itemMenu = menuItem;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-active {
  @apply tw-text-primary;
  background: rgba(64, 119, 248, 0.1);
  color: #4077f8;
}

.menu-hover:hover {
  background: rgba(64, 119, 248, 0.1);
}

.app-main {
  padding: 0 8px;
  width: 100%;

  & > div:first-of-type {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.02);
  }
}
</style>
